function visibilidad<T extends Element>(cb: (dato: T) => void, ...datos: T[]) {
    const observer = new IntersectionObserver(entries => {
        entries
            .filter(x => x.isIntersecting)
            .map(x => x.target)
            .forEach(x => {
                cb(x as T);
                observer.unobserve(x);
            });
    });

    datos.forEach(dato => observer.observe(dato));
}

export default visibilidad;